import React from 'react';
import { GlobeIcon, GraduationCapIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-sky-100 bg-white px-4 py-12" data-id="element-207">
      <div className="mx-auto max-w-4xl text-center" data-id="element-208">
        <p className="inline-flex items-center gap-2 font-display text-lg font-bold text-primary" data-id="element-209">
          <GraduationCapIcon className="h-5 w-5 text-teal" data-id="element-210" /> COMPRA DIGITAL
          YA™
        </p>
        <p className="mt-3 font-bold text-slate-700" data-id="element-211">
          El sistema N°1 para entrenadores de Futsal en Argentina.
        </p>
        <p className="mt-2 text-sm font-medium text-slate-500" data-id="element-212">
          Porque entrenar Futsal merece tener un sistema real.
        </p>
        <div className="mt-7 flex flex-col items-center justify-center gap-3 text-sm font-medium text-slate-600 sm:flex-row sm:gap-6" data-id="element-213">
          <a className="inline-flex items-center gap-1.5 transition-colors hover:text-teal" href="mailto:compradigitalyaa@gmail.com" data-id="element-214">
            <MailIcon className="h-4 w-4" data-id="element-215" /> compradigitalyaa@gmail.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors hover:text-teal" href="https://compradigitalya.com" target="_blank" rel="noopener noreferrer" data-id="element-216">
            <GlobeIcon className="h-4 w-4" data-id="element-217" /> compradigitalya.com
          </a>
        </div>
        <p className="mt-7 border-t border-slate-100 pt-6 text-xs font-medium text-slate-400" data-id="element-218">
          © Compra Digital Ya™ 2026 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}